import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Button,
  Chip
} from '@mui/material';
import { 
  LiveTv as LiveGamesIcon,
  Refresh as RefreshIcon,
  Schedule as ScheduleIcon
} from '@mui/icons-material';
import { fetchLiveGames } from '../../services/oddsApi';
import LiveGamesList from '../LiveGamesList';
import BackButton from '../BackButton';

const LiveGamesScreen = () => {
  const [liveGames, setLiveGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    loadLiveGames();
    
    // Set up auto-refresh for live games every 30 seconds
    const interval = setInterval(() => {
      loadLiveGames(true); // Silent refresh
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const loadLiveGames = async (silent = false) => {
    if (!silent) {
      setLoading(true);
    }
    setError(null);
    
    try {
      console.log('Loading live games...');
      const gamesData = await fetchLiveGames();
      console.log('Live games received:', gamesData);
      setLiveGames(gamesData);
      setLastUpdated(new Date());
    } catch (err) {
      console.error('Error loading live games:', err);
      setError('Failed to load live games. Please check your API configuration.');
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  };

  const handleRefresh = () => {
    loadLiveGames();
  };

  if (loading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="200px">
        <CircularProgress />
        <Typography variant="body2" color="text.secondary" mt={2}>
          Loading live games...
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <BackButton />
      {/* Header */}
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <Box display="flex" alignItems="center" justifyContent="center" gap={1} mb={2}>
          <LiveGamesIcon sx={{ fontSize: 32, color: 'warning.main' }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'warning.main' }}>
            Live Games
          </Typography>
        </Box>
        
        <Typography variant="body1" color="text.secondary" mb={3}>
          Track live games and real-time odds changes as they happen
        </Typography>

        {/* Live indicator */}
        <Chip
          icon={<LiveGamesIcon />}
          label={`${liveGames.length} Live Games`}
          sx={{ 
            mb: 2,
            bgcolor: 'warning.main',
            color: 'white',
            '& .MuiChip-icon': {
              color: 'white'
            }
          }}
        />


      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
          <Button 
            color="inherit" 
            size="small" 
            onClick={handleRefresh}
            sx={{ ml: 2 }}
          >
            Try Again
          </Button>
        </Alert>
      )}

      {/* Live Games List */}
      <LiveGamesList 
        odds={liveGames} 
      />

      {/* Auto-refresh notice */}
      <Box textAlign="center" mt={3}>
        <Typography variant="caption" color="text.secondary">
          Live odds update automatically every 30 seconds
        </Typography>
      </Box>
    </Box>
  );
};

export default LiveGamesScreen;
